import React, { useState, useEffect } from "react";
import styles from "./Account.module.css";
import {
    FaEnvelope,
    FaPhone,
    FaShieldAlt,
    FaFileAlt,
    FaUser,
} from "react-icons/fa";
// import styles from "./kohere.module.css";
import { useNavigate } from "react-router-dom";
import {
    getMykohere,
    resetPassword,
    getTeamsByUserId,
} from "../../Services/APIrequests";
import { updateUserdetails } from "../../Services/APIrequests";
import { SuccessSwal, warningSwal } from "../../Util/Toast";
import CreateTeamModal from "./CreateTeamModal";
import { useLocation } from "react-router-dom";
const Myaccount = ({ setTeams, teams, setActiveTab }) => {
    const [active, setActive] = useState("personalInfo"); // State to track active tab
    const [errorMessage, setErrorMessage] = useState("");
    const [subBtnstatus, setSubBtnStatus] = useState(1);
    const location = useLocation();
    const navigate = useNavigate();
    const [isEditingName, setIsEditingName] = useState(false);
    const [isEditingEmail, setIsEditingEmail] = useState(false);
    const [isEditingMobile, setIsEditingMobile] = useState(false);
    const [isEditingGSTIN, setIsEditingGSTIN] = useState(false);
    const [isEditingPassword, setIsEditingPassword] = useState(false);
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [newName, setNewName] = useState("");
    const [newEmail, setNewEmail] = useState("");
    const [newPhone, setNewPhone] = useState("");
    const [newgstIn, setNewGstIn] = useState("");
    const [userData, setUserData] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Function to handle tab change
    const handleTabChange = (tab) => {
        setActive(tab);
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    // const handleButtonClick = (index) => {
    //   setActiveTab(index);
    // };

    // const handleTabClick = (index) => {
    //   setActiveTab(index);
    // };

    // const isActivesubButton = (subbtnStatus) => {
    //   return subBtnstatus === subbtnStatus ? styles.btnActive : "";
    // };

    const handleLogout = () => {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("activeTab");
        navigate("/");
    };

    const handleterms = () => {
        navigate("/Terms_Conditions");
    };

    const fetchUserData = async () => {
        const token = sessionStorage.getItem("token");
        if (!token) {
            navigate("/");
            return;
        }
        try {
            const response = await getMykohere(token);
            setUserData(response.data.user);
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    useEffect(() => {
        fetchUserData();
    }, [navigate]);

    const handleNameChange = (e) => {
        setNewName(e.target.value);
    };

    const handleEmailChange = (e) => {
        setNewEmail(e.target.value);
    };

    const handleMobileChange = (e) => {
        setNewPhone(e.target.value);
    };

    const handleGstinChange = (e) => {
        setNewGstIn(e.target.value);
    };

    const handleChangeNameClick = () => {
        setIsEditingName(true);
    };

    const handleChangeEmailClick = () => {
        setIsEditingEmail(true);
    };

    const handleChangeMobileClick = () => {
        setIsEditingMobile(true);
    };

    const handleChangeGSTINClick = () => {
        setIsEditingGSTIN(true);
    };

    const handleCancelEdit = () => {
        setIsEditingName(false);
        setIsEditingEmail(false);
        setIsEditingMobile(false);
        setIsEditingGSTIN(false);
        setIsEditingPassword(false);
        setNewName("");
        setNewEmail("");
        setNewPhone("");
        setNewGstIn("");
        setNewPassword("");
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;

        if (name === "currentPassword") {
            setCurrentPassword(value);
        } else if (name === "newPassword") {
            setNewPassword(value);
        } else if (name === "confirmPassword") {
            setConfirmPassword(value);
        }
    };
    const handleSubmitPassword = async () => {
        const body = {
            newPassword: newPassword,
            confirmPassword: confirmPassword,
        };

        try {
            const response = await resetPassword(body);
            if (response?.status === 200) {
                SuccessSwal("Success", response.data.message);
                navigate("/login", { state: { from: location.pathname } });
            } else {
                setErrorMessage(response.data.message);
            }
        } catch (error) {
            warningSwal(
                "Error",
                error.response?.data?.message || "Something went wrong"
            );
        }
    };

    const handleUpdateDetails = async (key) => {
        const updateData = {};
        if (key === "userName") updateData.userName = newName;
        if (key === "emailId") updateData.emailId = newEmail;
        if (key === "mobileNumber") updateData.mobileNumber = newPhone;
        if (key === "gstin") updateData.gstin = newgstIn;

        if (!updateData[key].trim()) {
            warningSwal("Error", `Please provide a valid ${key} to update`);
            return;
        }

        try {
            const response = await updateUserdetails(updateData);
            if (response.status === 200) {
                setUserData((prev) => ({ ...prev, ...updateData }));
                SuccessSwal("Success", `${response.data.message}`);
                handleCancelEdit();
            } else {
                warningSwal(
                    "Error",
                    `Failed to update ${key}: ${response.data.message}`
                );
            }
        } catch (error) {
            if (
                error.response &&
                error.response.data &&
                error.response.data.message
            ) {
                warningSwal("Error", error.response.data.message);
            } else {
                warningSwal(
                    "Error",
                    `An error occurred while updating ${key}. Please try again.`
                );
            }
        }
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            setErrorMessage("Passwords do not match!");
            return;
        }

        const body = {
            currentPassword,
            newPassword,
            confirmPassword,
        };

        try {
            const response = await resetPassword(body);
            if (response?.status === 200) {
                SuccessSwal("Success", response.data.message);
                navigate("/login", { state: { from: location.pathname } });
            } else {
                setErrorMessage(response.data.message);
            }
        } catch (error) {
            warningSwal(
                "Error",
                error.response?.data?.message || "Something went wrong"
            );
        }
    };

    const fetchTeams = async () => {
        try {
            const response = await getTeamsByUserId();
            if (response.data.success) {
                setTeams(response.data.teams || []);
            }
        } catch (error) {
            console.error("Failed to fetch teams:", error);
        }
    };

    useEffect(() => {
        fetchTeams(); // Fetch teams on component mount
    }, []);

    return (
        <div className={styles.accountContainer}>
            <div className={styles.accountSidebar}>
                <ul>
                    <li
                        className={
                            active === "personalInfo"
                                ? styles.accountActive
                                : ""
                        }
                        onClick={() => handleTabChange("personalInfo")}>
                        <FaUser className={styles.accountIcon} /> Personal Info
                    </li>
                    <li
                        className={
                            active === "CreateTeam" ? styles.accountActive : ""
                        }
                        onClick={() => handleTabChange("CreateTeam")}>
                        <FaUser className={styles.accountIcon} /> Create Team
                    </li>

                    <li
                        className={
                            active === "security" ? styles.accountActive : ""
                        }
                        onClick={() => handleTabChange("security")}>
                        <FaShieldAlt className={styles.accountIcon} /> GSTIN
                    </li>
                    <li
                        className={
                            active === "business" ? styles.accountActive : ""
                        }
                        onClick={() => handleTabChange("business")}>
                        <FaFileAlt className={styles.accountIcon} /> TERMS AND
                        CONDITIONS
                    </li>
                </ul>
            </div>
            <div className={styles.accountmain_container}>
                <div className={styles.accountProfile}>
                    <div className={styles.accountRow}>
                        <div className={styles.accountAvatar}>
                            <span className={styles.accountstartletter}>
                                {userData
                                    ? userData.userName.charAt(0).toUpperCase()
                                    : ""}
                            </span>
                        </div>
                        <div className={styles.account_data_values}>
                            <span className={styles.account_data_heading}>
                                Profile Name
                            </span>
                            <span>
                                {userData ? userData.userName : "Loading..."}
                            </span>
                            {isEditingName && (
                                <div>
                                    <input
                                        type="text"
                                        value={newName}
                                        onChange={handleNameChange}
                                        placeholder="Enter new name"
                                        className={styles.nameInput}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div>
                        <p
                            id={styles.peditbtns}
                            onClick={handleChangeNameClick}>
                            Update Name
                        </p>
                        {isEditingName && (
                            <div className={styles.nameInputbuttons}>
                                <button
                                    onClick={handleCancelEdit}
                                    className={styles.profilecancel}>
                                    Cancel
                                </button>
                                <button
                                    className={styles.profileupdate}
                                    onClick={() =>
                                        handleUpdateDetails("userName")
                                    }>
                                    Update
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <div className={styles.accountMain}>
                    <div className={styles.accountDetails}>
                        {active === "personalInfo" && (
                            <>
                                <div className={styles.account_data}>
                                    <div className={styles.accountRow}>
                                        <div>
                                            <FaEnvelope
                                                className={styles.accountIcon}
                                            />
                                        </div>
                                        <div
                                            className={
                                                styles.account_data_values
                                            }>
                                            <span
                                                className={
                                                    styles.account_data_heading
                                                }>
                                                Email Address
                                            </span>
                                            <span>
                                                {userData
                                                    ? userData.emailId
                                                    : "Loading..."}
                                            </span>
                                            {isEditingEmail && (
                                                <input
                                                    type="email"
                                                    value={newEmail}
                                                    onChange={handleEmailChange}
                                                    placeholder="Enter new email"
                                                    className={styles.nameInput}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        <p
                                            id={styles.peditbtns}
                                            onClick={handleChangeEmailClick}>
                                            Update email
                                        </p>

                                        {isEditingEmail && (
                                            <div
                                                className={
                                                    styles.nameInputbuttons
                                                }>
                                                <button
                                                    onClick={handleCancelEdit}
                                                    className={
                                                        styles.profilecancel
                                                    }>
                                                    Cancel
                                                </button>
                                                <button
                                                    className={
                                                        styles.profileupdate
                                                    }
                                                    onClick={() =>
                                                        handleUpdateDetails(
                                                            "emailId"
                                                        )
                                                    }>
                                                    Update
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className={styles.account_data}>
                                    <div className={styles.accountRow}>
                                        <div>
                                            <FaPhone
                                                className={styles.accountIcon}
                                            />
                                        </div>
                                        <div
                                            className={
                                                styles.account_data_values
                                            }>
                                            <span
                                                className={
                                                    styles.account_data_heading
                                                }>
                                                Phone Number
                                            </span>
                                            <span>
                                                {userData
                                                    ? `+91-${userData.mobileNumber}`
                                                    : "Loading..."}
                                            </span>
                                            {isEditingMobile && (
                                                <input
                                                    type="text"
                                                    value={newPhone}
                                                    onChange={
                                                        handleMobileChange
                                                    }
                                                    placeholder="Enter new mobile number"
                                                    className={styles.nameInput}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        <p
                                            id={styles.peditbtns}
                                            className={styles.peditbtns}
                                            onClick={handleChangeMobileClick}>
                                            Update Mobile Number
                                        </p>
                                        {isEditingMobile && (
                                            <div
                                                className={
                                                    styles.nameInputbuttons
                                                }>
                                                <button
                                                    onClick={handleCancelEdit}
                                                    className={
                                                        styles.profilecancel
                                                    }>
                                                    Cancel
                                                </button>
                                                <button
                                                    onClick={() =>
                                                        handleUpdateDetails(
                                                            "mobileNumber"
                                                        )
                                                    }
                                                    className={
                                                        styles.profileupdate
                                                    }>
                                                    Update
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className={styles.account_data}>
                                    <div className={styles.accountRow}>
                                        <div>
                                            <FaShieldAlt
                                                className={styles.accountIcon}
                                            />
                                        </div>
                                        <div
                                            className={
                                                styles.account_data_values
                                            }>
                                            <span
                                                className={
                                                    styles.account_data_heading
                                                }>
                                                Password
                                            </span>
                                            <span>********</span>
                                            {isEditingPassword && (
                                                <form onSubmit={onSubmit}>
                                                    <div
                                                        className={
                                                            styles.inputGroup
                                                        }>
                                                        <input
                                                            type="password"
                                                            name="currentPassword"
                                                            value={
                                                                currentPassword
                                                            }
                                                            onChange={
                                                                handlePasswordChange
                                                            }
                                                            placeholder="Current Password"
                                                            className={
                                                                styles.nameInput
                                                            }
                                                            required
                                                        />
                                                    </div>
                                                    <div
                                                        className={
                                                            styles.inputGroup
                                                        }>
                                                        <input
                                                            type="password"
                                                            name="newPassword"
                                                            value={newPassword}
                                                            onChange={
                                                                handlePasswordChange
                                                            }
                                                            placeholder="Your New Password"
                                                            className={
                                                                styles.nameInput
                                                            }
                                                            required
                                                        />
                                                        {/* <span className={styles.passwordHint}>
                          8 characters minimum
                        </span> */}
                                                    </div>
                                                    <div
                                                        className={
                                                            styles.inputGroup
                                                        }>
                                                        <input
                                                            type="password"
                                                            name="confirmPassword"
                                                            value={
                                                                confirmPassword
                                                            }
                                                            onChange={
                                                                handlePasswordChange
                                                            }
                                                            placeholder="Re-enter Your Password"
                                                            className={
                                                                styles.nameInput
                                                            }
                                                            required
                                                        />
                                                    </div>
                                                </form>
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        <p
                                            className={styles.peditbtns}
                                            id={styles.peditbtns}
                                            onClick={() =>
                                                setIsEditingPassword(true)
                                            }
                                            style={{ cursor: "pointer" }}>
                                            Update Password
                                        </p>
                                        {isEditingPassword && (
                                            <div
                                                className={
                                                    styles.nameInputbuttons
                                                }>
                                                <button
                                                    className={
                                                        styles.profileupdate
                                                    }
                                                    onClick={
                                                        handleSubmitPassword
                                                    }>
                                                    Change Password
                                                </button>
                                                <button
                                                    type="button"
                                                    className={
                                                        styles.profilecancel
                                                    }
                                                    onClick={() =>
                                                        setIsEditingPassword(
                                                            false
                                                        )
                                                    }>
                                                    Cancel
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}

                        {active === "CreateTeam" && (
                            <div>
                                <div className={styles.profile_btns_containeer}>
                                    <button
                                        className="create-team-button"
                                        onClick={openModal}>
                                        Create Team
                                    </button>

                                    {isModalOpen && (
                                        <CreateTeamModal
                                            setteams={setTeams}
                                            setActiveTab={setActiveTab}
                                            fetchTeams={fetchTeams}
                                            onClose={closeModal}
                                        />
                                    )}
                                </div>
                            </div>
                        )}

                        {active === "security" && (
                            <div>
                                <div className={styles.account_data}>
                                    <div className={styles.accountRow}>
                                        <div>
                                            <FaFileAlt
                                                className={styles.accountIcon}
                                            />
                                        </div>
                                        <div
                                            className={
                                                styles.account_data_values
                                            }>
                                            <span
                                                className={
                                                    styles.account_data_heading
                                                }>
                                                GSTIN
                                            </span>
                                            <span>
                                                {userData && userData.gstin
                                                    ? userData.gstin
                                                    : "Not provided"}
                                            </span>
                                            {isEditingGSTIN && (
                                                <input
                                                    type="text"
                                                    value={newgstIn}
                                                    onChange={handleGstinChange}
                                                    placeholder="Enter new GSTIN"
                                                    className={styles.nameInput}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        <p
                                            id={styles.peditbtns}
                                            className={styles.peditbtns}
                                            onClick={handleChangeGSTINClick}>
                                            Add GSTIN
                                        </p>
                                        {isEditingGSTIN && (
                                            <div
                                                className={
                                                    styles.nameInputbuttons
                                                }>
                                                <button
                                                    onClick={handleCancelEdit}
                                                    className={
                                                        styles.profilecancel
                                                    }>
                                                    Cancel
                                                </button>
                                                <button
                                                    onClick={() =>
                                                        handleUpdateDetails(
                                                            "gstin"
                                                        )
                                                    }
                                                    className={
                                                        styles.profileupdate
                                                    }>
                                                    Update
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {active === "business" && (
                            <div>
                                <div className={styles.account_data}>
                                    <div className={styles.accountRow}>
                                        <div>
                                            <FaFileAlt
                                                className={styles.accountIcon}
                                            />
                                        </div>
                                        <div
                                            className={
                                                styles.account_data_values
                                            }>
                                            <span
                                                className={
                                                    styles.account_data_heading
                                                }>
                                                Terms & Conditions
                                            </span>
                                            <span>
                                                Accepted on:{" "}
                                                {userData &&
                                                userData.termsAndConditions
                                                    ? userData.termsAndConditions
                                                    : "-"}
                                            </span>
                                        </div>
                                    </div>
                                    <div>
                                        <p
                                            className={styles.peditbtns}
                                            onClick={handleterms}>
                                            Terms
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Myaccount;
